
import TranResourcesApi from './src/Tranresources'
import RegionList from './src/RegionList'


let apis = {
   TranResourcesApi,
   RegionList
};

export default apis;
